/**
 * Pages that moved to the four-tab URLs (spec §3), new path → the old path their per-page
 * config is keyed by: page tours, animation presets, the player's saved per-page animation
 * setting (stored under the old route) and the header config. The old URLs redirect (router.tsx).
 */
const MOVED_PAGES: Record<string, string> = {
  '/money/wallet': '/account/finance/wallet',
  '/money/history': '/account/transactions',
  '/money/games': '/account/games',
  '/me/details': '/account/settings',
  '/me/security': '/account/security',
  '/me/sound-motion': '/account/animations',
  '/me/messages': '/account/messages',
  // The FAQ moved into Help: Help keeps the FAQ page's animations and its Sound & motion switch.
  // (Ticket conversations keep the Support page's, below.)
  '/help': '/faq',
};

const HELP_TICKET_PREFIX = '/help/tickets/';

/** The old path for a moved page (ticket views included); any other path as it is. */
export function legacyPathFor(pathname: string): string {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (normalized.startsWith(HELP_TICKET_PREFIX)) {
    return `/support/tickets/${normalized.slice(HELP_TICKET_PREFIX.length)}`;
  }
  return MOVED_PAGES[normalized] ?? pathname;
}
